import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '@env/environment';
import { SharedModule } from '@shared/shared.module';

const versionUrl = `${environment.apiBaseUrl}platform/version`;

@Injectable({
  providedIn: SharedModule
})
export class VersionService {

  constructor(private http: HttpClient) { }

  get(): Observable<Version.BEVersionModel> {
    return this.http.get<Version.BEVersionModel>(`${versionUrl}`);
  }
}
